import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pwaApi } from '../../lib/api.js';
import { useSessionStore } from '../../store/sessionStore.js';

interface LanguageOption {
  id: number;
  code: string;
  nameNative: string;
}

export default function SettingsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { language, setLanguage } = useSessionStore();
  const [languages, setLanguages] = useState<LanguageOption[]>([]);

  useEffect(() => {
    pwaApi.get('/tablet/languages').then(({ data }) => setLanguages(data.data as LanguageOption[])).catch(() => {});
  }, []);

  return (
    <div className="h-full overflow-y-auto" style={{ background: '#1a1a2e' }}>
      <div className="flex items-center gap-4 px-4 h-16 bg-gray-900 border-b border-gray-700">
        <button onClick={() => navigate('/workstation')} className="bg-gray-700 hover:bg-gray-600 active:bg-gray-500 text-white px-5 py-3 rounded-lg font-bold text-sm">
          {t('settings.back')}
        </button>
        <div className="text-white font-bold">{t('settings.title')}</div>
      </div>

      <div className="p-6 max-w-md mx-auto space-y-3">
        <div className="text-gray-300 font-bold text-sm mb-2">{t('settings.language')}</div>
        <div className="grid grid-cols-3 gap-3">
          {languages.map(l => (
            <button
              key={l.code}
              onClick={() => setLanguage(l.code)}
              className={`h-20 rounded-lg font-bold text-lg transition-all ${
                language === l.code
                  ? 'bg-blue-600 text-white ring-2 ring-blue-400'
                  : 'bg-gray-800 text-gray-200 hover:bg-gray-700 border border-gray-700'
              }`}
            >
              {l.nameNative}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
